export const storageKeys = {
  access_and_token: "x-ofv2-access",
  settings: "ofv2-settings",
  user_data: "ofv2-user-data"
};
